<div
  style="margin-left: -1.5rem !important; margin-right: -1.5rem !important"
  class="px-4 py-1 bg-white"
>
  <ion-list lines="none">
    <ion-item>
      <div>
        <ion-label>{{ title }} </ion-label>
        <div>
          @if (pressable) {
            <app-link color="warning" (linkClick)="this.onPress.emit()">{{
              ctaText
            }}</app-link>
          } @else {
            <ion-label class="fw-regular">{{ ctaText }} </ion-label>
          }
        </div>
      </div>

      @if (warning) {
        <div slot="end" class="color-medium">
          <i class="fa-solid {{ icon }} color-orange"></i>
        </div>
      } @else {
        <div slot="end" class="color-medium">
          {{ notWarning }}
        </div>
      }
    </ion-item>
  </ion-list>
</div>
